import styled from "styled-components"

export const ModalHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;

    padding: 2rem 45px;
    margin-bottom: 2rem;

    border-bottom: 1px solid var(--mantine-color-gray-2);

    & svg {
        transform: rotate(45deg);
    }
`

export const ModalDescription = styled.p`
    color: var(--mantine-color-gray-7);
    font-size: 0.875rem;
    line-height: 150%;

    min-height: 28px;
`

export const ModalTitle = styled.h2`
    color: var(--mantine-color-gray-8);
    text-align: center;
    font-size: 1.25rem;
    font-weight: 500;
    line-height: 150%;

    margin-top: 0;
    margin-bottom: 0;
`

export const ModalButtonContainer = styled.div`
    display: flex;
    align-items: center;

    gap: var(--mantine-spacing-xs);

    & button {
        border-radius: 2rem;
        padding-inline: 1.5rem;
    }
`
